import { useTranslation } from 'react-i18next';
const prefix = 'studentManagement.tabs.petitionsHistory';
const tablePrefix = `${prefix}.table`;
const detailPrefix = `${prefix}.detail`;
export function useTexts() {
  const { t } = useTranslation();
  return {
    table: {
      folio: t(`${tablePrefix}.folio`),
      createdAt: t(`${tablePrefix}.createdAt`),
      studyPlanVersionName: t(`${tablePrefix}.studyPlanVersionName`),
      typeName: t(`${tablePrefix}.typeName`),
      title: t(`${tablePrefix}.title`),
      status: t(`${tablePrefix}.status`),
      paymentStatus: t(`${tablePrefix}.paymentStatus`),
      viewDetail: t(`${tablePrefix}.viewDetail`),
    },
    detail: {
      resume: {
        petitionResumeTitle: t(`${detailPrefix}.resume.petitionResumeTitle`),
        petitionResumeSubTitle: t(
          `${detailPrefix}.resume.petitionResumeSubTitle`,
        ),
        title: t(`${detailPrefix}.resume.title`),
        section: t(`${detailPrefix}.resume.section`),
        type: t(`${detailPrefix}.resume.type`),
        studyPlan: t(`${detailPrefix}.resume.studyPlan`),
        date: t(`${detailPrefix}.resume.date`),
        evaluationDate: t(`${detailPrefix}.resume.evaluationDate`),
        price: t(`${detailPrefix}.resume.price`),
        paidAt: t(`${detailPrefix}.resume.paidAt`),
        finish: t(`${detailPrefix}.resume.finish`),
      },
      reason: {
        reasonTitle: t(`${detailPrefix}.reason.reasonTitle`),
      },
      resolution: {
        resolutionTitle: t(`${detailPrefix}.resolution.resolutionTitle`),
        resolutionDate: t(`${detailPrefix}.resolution.resolutionDate`),
      },
      inputTooltips: {
        tooltips: {
          resuelta: t(`${detailPrefix}.resolution.tooltips.resuelta`),
          aprobada: t(`${detailPrefix}.resolution.tooltips.aprobada`),
          rechazada: t(`${detailPrefix}.resolution.tooltips.rechazada`),
          recibida: t(`${detailPrefix}.resolution.tooltips.recibida`),
          en_proceso: t(`${detailPrefix}.resolution.tooltips.en_proceso`),
          en_espera: t(`${detailPrefix}.resolution.tooltips.en_espera`),
        },
      },
      downloads: {
        fileLabel: t(`${detailPrefix}.downloads.fileLabel`),
        downloadHistory: t(`${detailPrefix}.downloads.downloadHistory`),
        downloadFailed: t(`${detailPrefix}.downloads.downloadFailed`),
        downloadSuccess: t(`${detailPrefix}.downloads.downloadSuccess`),
        voucher: t(`${detailPrefix}.downloads.voucher`),
        voucherLabel: t(`${detailPrefix}.downloads.voucherLabel`),
      },
    },
  };
}
